export const AppConsts = {
  FILENAME_PROFILE_AVATAR: 'profile_avatar_pic',
  FILENAME_PROFILE_PRO_AVATAR: 'profile_pro_avatar_pic'
};
